import { useFormik } from "formik";
import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import useTailoring from "../hooks/useTailoring";
// import { MakeTailoringContext } from "./MakeTailoringContext";
// import { CartModalContext } from "./CartModalContext";
import { UserContext } from "./userContext";

export const AddToCartContext = createContext();

export const AddToCartProvider = ({ children }) => {
  const [cartProductId, setCartProductId] = useState("");
  const [whatsappContact, setwhatsappContact] = useState(null);
  const [delivery, setDelivery] = useState(null);
  const [from_state, setFrom_state] = useState(null);
  const [to_state, setTo_State] = useState(null);
  const [toLga, setToLga] = useState(null);
  const [size, setSize] = useState(null);
  const [delivery_address, setDelivery_address] = useState(null);
  const [pick_up, setPick_up] = useState(null);
  const [orderID, setOrderID] = useState()

  const [checkoutItemDetails, setCheckoutItemDetails] = useState(null)

  // const { productId } = useContext(MakeTailoringContext);
  const { userData } = useContext(UserContext);
  const user = userData?.user || {};
  const first_name = user?.first_name;
  const last_name = user?.last_name;
  const email = user?.email;

  const { handleAddToCart } = useTailoring();

  const navigate = useNavigate()

  function storeInLocalStorage(item, keyAndvalue) {
    let data = localStorage.getItem(item);
    data = data ? JSON.parse(data) : [];
    data.push(keyAndvalue);
    localStorage.setItem(item, JSON.stringify(data));
  }


  const addToCart = (values) => {
    const payload = {
      values,
      id: cartProductId,
    };
    const payload_2 = {
      values,
      id: orderID,
    }
    handleAddToCart(payload).then((res) => {
      storeInLocalStorage("cart_order", res?.data.response);
      setCheckoutItemDetails(res?.data.response)
      // window.location.reload()
    }).then(() => {
      // setShowCart(true);
      navigate("/cartitem")
    })
    handleAddToCart(payload_2).then(res => {
      localStorage.setItem("checkoutItem", JSON.stringify(res?.data.response));
    })
  };

  const addToCartFormik = useFormik({
    initialValues: {
      first_name,
      last_name,
      email,
      size,
      delivery,
      delivery_address,
      pick_up,
      from_state,
      lga: toLga,
      to_state,
      quantity: 1,
      whatsapp_number: whatsappContact,
    },
    onSubmit: (values) => {
      addToCart({
        ...values,
        whatsapp_number: whatsappContact,
        delivery,
        lga: toLga,
        to_state,
        from_state,
        size,
        delivery_address,
        pick_up,
      });
      console.log(values);
    },
  });

  const addToCartValues = {
    addToCartFormik,
    checkoutItemDetails,
    setCartProductId,
    setwhatsappContact,
    setDelivery,
    setFrom_state,
    setTo_State,
    setToLga,
    setSize,
    setDelivery_address,
    setPick_up,
    setOrderID
  };

   return (
    <AddToCartContext.Provider value={addToCartValues}>
      {children}
    </AddToCartContext.Provider>
  );
};
